"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _layout = _interopRequireDefault(require("./layout"));

/**
 * Use Donut to display a Donut graph component
 *
 * Example:
 *
 * ```js
 * <Donut value={25}> The progress is 25% </Donut>
 * ```
 */
var _default = _layout["default"];
exports["default"] = _default;